import Vue from 'vue'

export default [
  {
    path: '/household/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'householdDashboard',
        component: () => import('@/views/Household/HouseholdDashboard.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      {
        path: 'property',
        name: 'householdProperty',
        component: () => import('@/views/Household/PropertyView.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      {
        path: 'detail/:id',
        name: 'householdDetail',
        component: () => import('@/views/Household/DetailView.vue'),
        meta: {
          prev: 'householdDashboard'
        }
      },
      {
        path: 'detail/',
        redirect: { name: 'householdProperty' }
      }
    ],
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('loginUserInfo') && !JSON.parse(localStorage.getItem('loginUserInfo'))) {
        Vue.prototype.$alert('登入過期或驗證失敗，請重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          next({ name: 'LoginMain' })
        })
      } else {
        next()
      }
    }
  }
]
